import { createContext } from 'react';

export interface Coords {
    lat?: number;
    lng?: number;
}

interface LabelValue {
    label: string;
    value: string | number;
}
export interface Filters {
    stockistType?: string;
    brand?: LabelValue;
    product?: LabelValue;
}

interface ContextProps {
    selectedLatLng: Coords;
    setSelectedLatLng: any;
    selectedDescription: string;
    setSelectedDescription: any;
    searchType: 'GEO' | 'SEARCHED' | 'AREA' | 'DEFAULT';
    setSearchType: any;
    filters: Filters;
    setFilters: any;
    brand?: string;
    product?: string;
    layout?: 'horz' | 'vert';
    basic?: boolean;
}
const LocationContext = createContext<Partial<ContextProps>>({});
export default LocationContext;
